import { requestWithToken } from "../utils/apis";

export const AccessLevels = async () => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/access-level`,
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const roleList = async (page, limit) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/role/list?page=${page}&limit=${limit}`,
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const createRole = async (payload) => {
    try {
      const response = await requestWithToken(
        "POST",
          `/api/role`,
          payload
      );
  
      return response.data;
    } catch (err) {
      return err.response.data;
    }
};

export const editRole = async (id,payload) => {
    try {
      const response = await requestWithToken(
        "PUT",
          `/api/role/${id}`,
          payload
      );
  
      return response.data;
    } catch (err) {
      return err.response.data;
    }
};
  
export const deleteRole = async (id) => {
    try {
      const response = await requestWithToken(
        "DELETE",
          `/api/role/${id}`,
      );
  
      return response.data;
    } catch (err) {
      return err.response.data;
    }
};

export const activateRole = async (id) => {
  try {
    const response = await requestWithToken(
      "PUT",
        `/api/role/${id}/activate`,
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
  
export const roleDetails = async (id) => {
  try {
    const response = await requestWithToken("GET", `/api/role/${id}`);

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};